import PhoneArea from "components/PhonePreview/PhoneArea"
import React from "react"

const Preview = ({
  title = "",
  subtitle = "",
  textColor,
  bgImage,
  bgColor,
  content = "",
  img,
  imgCaption = "",
  font = "",
}) => {
  return (
    <PhoneArea>
      <div
        className="col-auto pt-1 px-1"
        style={{
          width: "105%",
          height: "20%",
          marginLeft: "-5px",
          background: "white",
        }}
      >
        <i className="bx bx-sm bx-x" style={{ cursor: "pointer" }} />
        <div style={{ fontSize: "20px", textAlign: "center" }}>{title}</div>
      </div>
      <div
        style={{
          backgroundImage: `url(${bgImage})`,
          backgroundColor: bgColor,
          width: "105%",
          height: "105%",
          backgroundSize: "cover",
          marginLeft: "-5px",
          backgroundPosition: "center center",
          boxShadow: "inset 0 0 0 500px rgb(0 0 0 / 40%)",
        }}
      >
        {img && (
          <div
            style={{
              backgroundImage: `url(${img})`,
              width: "100%",
              height: "35%",
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
          />
        )}
        <div
          className="ms-3"
          style={{ fontSize: "10px", color: textColor, fontFamily: font }}
        >
          {imgCaption}
        </div>
        <div
          className="my-2"
          style={{
            fontSize: "18px",
            textAlign: "center",
            color: textColor,
            fontFamily: font,
          }}
        >
          {subtitle}
        </div>
        <div
          dangerouslySetInnerHTML={{ __html: content }}
          className="ms-3"
          style={{ fontSize: "14px", color: textColor }}
        />
      </div>
    </PhoneArea>
  )
}

export default Preview
